import { Card } from "antd";
import React, { useState } from "react";
import Confetti from 'react-confetti';
import "./Registration.css";
import RegistrationBuilder from "./RegistrationBuilder";

function RegistrationController() {
  const queryParams = new URLSearchParams(window.location.search);
  const referrerCode = queryParams.get("referrer-code") ?? "";
  const sessionUuid = queryParams.get("session_uuid") ?? "";
  const platform = queryParams.get("platform") || "yeti";
  const [activeStep, setSteps] = useState("user");
  const [userData, setUserData] = useState({
    platform,
    contactId: "",
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    phoneNumber: "",
    password: "",
    passwordConfirmation: "",
    platformName: "",
    creditCardId: "",
    activeCampaignUsername: "",
    activeCampaignApiKey: "",
    pricingPlanId: 16,
    phoneNumberVerificationCode: "",
    lastPhoneNumberVerificationCode: "",
    isPhoneVerified: false,
    acceptedConditions: false,
    isAgencyAccount: false,
    referrerCode,
    sessionUuid,
    sessionKey: "",
    existingCreditCards: [],
    changeStep: null,
    setValues: null,
    timeZone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || "America/Los_Angeles",
  });

  const setActiveData = () => {
    let block = [];

    userData.changeStep = changeSteps;
    userData.setValues = setValues;
    if (activeStep) {
      block = [activeStep, userData];
    }
    return block;
  };

  const setValues = (valueObject) => {
    const newObj = { ...userData, ...valueObject };
    setUserData(newObj);
  };

  const changeSteps = (key) => {
    setSteps(key);
  };

  const block = setActiveData();

  const registrationTitle = sessionUuid ? "Linked Account Registration" : "Registration";
  return (
    <div>
      <div className="card-wrapper">
        <Card style={{ width: '60vw' }} title={registrationTitle}>
          {block[0] && RegistrationBuilder(block)}
        </Card>
      </div>
      {activeStep === 'success' && <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
      />
      }
    </div>
  );
}

export default RegistrationController;
